import { range } from 'lodash'
import CertificateSubtypes from 'todistukset-common/src/vtj/CertificateSubtypes.enum'
import { TodistusPyyntö } from 'todistukset-common/src/vtj/types/todistus'
import {
  CertificateProductType,
  CertificateProductTypeId,
} from 'todistukset-common/src/vtj/types/price-list.type'
import { SingleSelectData } from 'suomifi-ui-components'
import { MAX_NUMBER_OF_MARRIAGES } from 'todistukset-common/src/vtj/validation'
import { finalEditableFieldValue } from 'todistukset-common/src/vtj/types/editable-field.type'
import { LanguageCode } from 'common/src/vtj/LanguageCode.enum'

export const TRANSLATION_FORM_IDENTIFIER = 'KAANNOSLOMAKKEELLA'

export const muuTodistusOverrideLanguages = [
  LanguageCode.ES,
  LanguageCode.IT,
  LanguageCode.FR,
  LanguageCode.DE,
]

export function createItemType({
  todistusType,
  todistusSubtype,
  includeTranslationForm,
  todistusLanguage,
}: Pick<
  TodistusPyyntö,
  'todistusType' | 'todistusSubtype' | 'includeTranslationForm'
> & {
  todistusLanguage: TodistusPyyntö['todistusLanguage'] | null
}): CertificateProductTypeId {
  if (todistusSubtype === CertificateSubtypes.ELOMAKE) {
    const todistusLanguageValue = finalEditableFieldValue(todistusLanguage)

    // If elomake todistus is ordered with a certain language, it will always be billed as "Muu todistus" even if the customer chose a different todistus type
    const productType =
      todistusLanguageValue &&
      muuTodistusOverrideLanguages.includes(todistusLanguageValue)
        ? CertificateProductType.MUU_MANUAALINEN_TODISTUS_ELOMAKE
        : `${todistusType}_${CertificateSubtypes.ELOMAKE}`

    return productType.toUpperCase() as CertificateProductTypeId
  }

  const includeTranslationFormValue = finalEditableFieldValue(
    includeTranslationForm
  )
  const subType = includeTranslationFormValue
    ? CertificateSubtypes.EU_VIRANOMAISELLE
    : todistusSubtype
  return `${todistusType}_${subType}${
    includeTranslationFormValue ? `_${TRANSLATION_FORM_IDENTIFIER}` : ''
  }`.toUpperCase() as CertificateProductTypeId
}

export const numberOfMarriagesSelectItems: SingleSelectData[] = range(
  MAX_NUMBER_OF_MARRIAGES + 1
).map((value) => {
  return {
    labelText: value.toString(),
    uniqueItemId: value.toString(),
  }
})
